import { useSetAtom, useAtomValue } from 'jotai';
import { parse } from 'qs';
import { isNil, omitBy } from 'lodash-es';
import { useHashModalAppRouter } from '@weberus/next-libs/feature/hash-modal-app-router';
import { generateHashedId } from '@weberus/utils';
import { MODAL__SWIPE_BACK__OPTION } from '@weberus/ui/utils/swipe-back-options';
import {
  globalFilterQueryStrAtom,
  tempGlobalFilterParamsAtom,
  globalFilterParamsAtom,
} from '@/app/_shared/store/search-filter';
import { GlobalFilterModalHashId } from '../utils/constants';
import { updateQueryAndScroll } from '../utils/update-query-and-scroll';

export const useSyncGlobalFilterWithQuery = () => {
  // store getter
  const globalFilterQueryStr = useAtomValue(globalFilterQueryStrAtom);
  const tempGlobalFilterParams = useAtomValue(tempGlobalFilterParamsAtom);

  // store setter
  const setGlobalFilterParams = useSetAtom(globalFilterParamsAtom);
  const [_, setIsGlobalFilterOpen] = useHashModalAppRouter({
    id: `hash-${generateHashedId(GlobalFilterModalHashId)}`,
    swipeBackOption: MODAL__SWIPE_BACK__OPTION,
  });

  const syncGlobalFilterWithQuery = () => {
    // 현재 쿼리 문자열 파싱
    const currentQuery = parse(new URLSearchParams(window.location.search).toString());

    // 새로운 쿼리 문자열 생성
    const newQuery = omitBy(
      {
        ...currentQuery,
        filter: globalFilterQueryStr.filterQuery,
        switchFilter: globalFilterQueryStr.switchFilterQuery,
        rangeFilter: globalFilterQueryStr.rangeFilterQuery,
      },
      (value) => isNil(value) || value === '',
    );

    // 글로벌 필터 상태 업데이트
    setGlobalFilterParams(tempGlobalFilterParams);

    // 필터 모달 닫기
    setIsGlobalFilterOpen(false);

    // URL 업데이트
    updateQueryAndScroll(newQuery);
  };

  return { syncGlobalFilterWithQuery };
};
